import styled from "styled-components";

export default styled.div`
  > svg {
    fill: ${props => props.muiTheme.palette.primary.main} !important;
  }
`;
